import React, { Fragment } from 'react';
import 'antd/dist/antd.css';
import BasicLayout from './layout/Basic'

function App() {
  return (
    <Fragment>
      <BasicLayout />
    </Fragment>
  );
}

export default App;
